/**
 * The single OperatorView-side definition of the host↔embed contract literals
 * shared with the embedded job-docs-client (ShopPulse documents).
 *
 * KEEP IN SYNC — there is NO compile-time check across repos. These literals
 * are mirrored by three artifacts that must move together; a rename on any one
 * side breaks the integration silently:
 *   - the embed-side counterpart `job-docs-client/app/src/utils/embedHostContract.ts`
 *     (mm-core), and
 *   - the written contract `job-docs-client/docs/HOST_EMBED.md`.
 *
 * Note: the drawer-close event is NOT defined here — that is
 * EmbeddedMMDrawer's generic `${messageSource}:${DRAWER_CLOSE_EVENT}` drawer
 * protocol, not a job-docs contract literal.
 */

/**
 * The single route the host addresses in the embedded job-docs-client;
 * everything past it — document routes, view state — is owned by the embed.
 */
export const JOB_DOCS_DOCUMENTS_PATH = '/shoppulse/documents';

/** Grid route query param: the part number of the operation. */
export const JOB_DOCS_PARAM_PART_NUMBER = 'partNumber';

/** Grid route query param: the operation id / sequence number. */
export const JOB_DOCS_PARAM_OPERATION_ID = 'operationId';

/**
 * Grid route query param: the part operation ref the embed filters documents
 * by. Required by the embed; mirrors `job-docs-client/app/src/utils/embedHostContract.ts:19`.
 */
export const JOB_DOCS_PARAM_PART_OPERATION_REF = 'partOperationRef';

/** Grid route query param: the (lowercased) activity mode used to filter. */
export const JOB_DOCS_PARAM_ACTIVITY_MODE = 'activityMode';

/** Grid route query param: the host-navigation marker. */
export const JOB_DOCS_PARAM_HOST_NAV = 'hostNav';

/**
 * `hostNav` value telling the embed to render opened documents in place (over
 * the still-mounted grid) instead of navigating.
 */
export const JOB_DOCS_HOST_NAV_INPLACE = 'inplace';

/**
 * Zone message the embed sends to announce the open document
 * (`{ summary: { title, fileLabel } }`, both null back on the grid).
 */
export const JOB_DOCS_EVENT_SET_SUMMARY = 'set-summary';

/**
 * Context key: an epoch-ms nonce the host bumps to ask the embed to close its
 * open document and return to the grid.
 */
export const JOB_DOCS_CONTEXT_DOC_BACK_KEY = 'docBackRequestedAt';
